/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable no-use-before-define */
import React, { useState, useEffect } from 'react';
import { AutoComplete, Input, Button, message, DatePicker, Space, Row, Col } from 'antd';
import { DataService } from '../../../../../config/dataService/dataService';

const CompanySelector = ({ onCompanySelect, selectedCompany, onFetchData, dateRange, onDateRangeChange, dataFetched = false }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedLabel, setSelectedLabel] = useState('');
  const [searchValue, setSearchValue] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [dateError, setDateError] = useState('');

  // Update local state when dateRange prop changes
  useEffect(() => {
    if (dateRange) {
      setStartDate(dateRange[0]);
      setEndDate(dateRange[1]);
    } else {
      setStartDate(null);
      setEndDate(null);
    }
    setDateError('');
  }, [dateRange]);

  // Fetch suggestions from API
  const fetchSuggestions = async (query) => {
    try {
      setLoading(true);
      const response = await DataService.post(`/comps/query-selector`, { search: query });
      const { data = [] } = response.data || {};

      const formattedOptions = data.map((item) => ({
        value: item.id,
        label: item.title,
      }));

      setOptions(formattedOptions);
      setLoading(false);
    } catch (error) {
      message.error(`Error fetching suggestions: ${error.message}`);
      setLoading(false);
    }
  };

  // Handle search input change
  const handleSearch = (value) => {
    setSearchValue(value);
    if (onCompanySelect) onCompanySelect(null);
    if (selectedLabel && String(selectedLabel).length > 0) setSelectedLabel('');
    if (value) {
      fetchSuggestions(value);
    } else {
      setOptions([]);
      setSelectedLabel('');
    }
  };

  // Handle item selection
  const handleSelect = (value, option) => {
    setSearchValue('');
    setSelectedLabel(option.label);
    if (onCompanySelect) onCompanySelect(value || null);
  };

  // Handle start date change
  const handleStartDateChange = (date) => {
    setStartDate(date);
    setDateError('');
    
    // If both dates are selected, validate and update parent
    if (date && endDate) {
      validateAndUpdateDates(date, endDate);
    }
  };

  // Handle end date change
  const handleEndDateChange = (date) => {
    setEndDate(date);
    setDateError('');
    
    // If both dates are selected, validate and update parent
    if (startDate && date) {
      validateAndUpdateDates(startDate, date);
    }
  };

  // Validate dates and update parent
  const validateAndUpdateDates = (start, end) => {
    if (!start || !end) {
      setDateError('Both start and end dates are required');
      onDateRangeChange(null);
      return;
    }

    // Check if start date is before or equal to end date
    if (start.isAfter(end)) {
      setDateError('Start date must be before or equal to end date');
      onDateRangeChange(null);
      return;
    }

    // All validations passed
    setDateError('');
    onDateRangeChange([start, end]);
  };

  // Handle fetch data button click
  const handleFetchData = () => {
    // Validate company selection
    if (!selectedCompany) {
      message.error('Please select a company first');
      return;
    }

    // Validate date range
    if (!startDate || !endDate) {
      setDateError('Both start and end dates are required');
      message.error('Please select both start and end dates');
      return;
    }

    if (startDate.isAfter(endDate)) {
      setDateError('Start date must be before or equal to end date');
      message.error('Start date must be before or equal to end date');
      return;
    }

    // All validations passed
    setDateError('');
    onFetchData();
  };

  // Check if fetch button should be enabled
  const isFetchEnabled = selectedCompany && startDate && endDate && !startDate.isAfter(endDate);

  return (
    <div className="text-center">
      <h1 className="text-4xl font-bold text-black mb-6">
        Company Data Report
      </h1>
      
      <div className="mb-6">
        <AutoComplete
          options={options}
          onSearch={handleSearch}
          onSelect={handleSelect}
          style={{ width: '100%' }}
          placeholder="Search and select a company..."
          allowClear
          value={selectedLabel || searchValue}
          notFoundContent={loading ? 'Loading...' : 'No Results Found'}
        >
          <Input 
            className='h-12 text-lg' 
            size="large"
            style={{ fontSize: '18px' }}
          />
        </AutoComplete>
      </div>

      <div className="mb-6">
        <Row gutter={16} justify="center">
          <Col xs={24} sm={12} md={8}>
            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Start Date *
              </label>
            </div>
            <DatePicker
              onChange={handleStartDateChange}
              value={startDate}
              allowClear
              placeholder="Select Start Date"
              size="large"
              style={{ width: '100%' }}
              format="DD/MM/YYYY"
            />
          </Col>
          <Col xs={24} sm={12} md={8}>
            <div className="mb-2">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                End Date *
              </label>
            </div>
            <DatePicker
              onChange={handleEndDateChange}
              value={endDate}
              allowClear
              placeholder="Select End Date"
              size="large"
              style={{ width: '100%' }}
              format="DD/MM/YYYY"
              disabledDate={(current) => {
                // Disable dates before start date
                return startDate && current && current.isBefore(startDate, 'day');
              }}
            />
          </Col>
        </Row>
        
        {dateError && (
          <div className="mt-2">
            <span className="text-red-500 text-sm">{dateError}</span>
          </div>
        )}
      </div>

      <Button
        type="primary"
        size="large"
        onClick={handleFetchData}
        disabled={!isFetchEnabled}
        className="h-12 px-8 text-lg font-semibold"
        style={{ 
          fontSize: '18px',
          backgroundColor: isFetchEnabled ? '#1890ff' : '#d9d9d9',
          borderColor: isFetchEnabled ? '#1890ff' : '#d9d9d9'
        }}
      >
        {dataFetched ? 'Reload Data' : 'Fetch Data'}
      </Button>
    </div>
  );
};

export default CompanySelector; 